<template>
  <div v-if="statut =='Abouti' && ifContratR2" class="file-section file-section--active">
    <div class="file-section-content">
      <div>
        <div class="file-circle file-circle--active"/>
      </div>
      <div class="file-section-content-label">Signature du dossier</div>
    </div>
  </div>
  <div v-else-if="statut =='Abouti'" class="file-section file-section--active">
    <div class="file-section-content">
      <div>
        <div class="file-circle file-circle--active"/>
      </div>
      <div class="file-section-content-label">Signature du dossier</div>
      <div>
        <div class="file-icon file-icon--active"><img src="@/assets/img/file/indicator.png"></div>
      </div>
    </div>
    <div class="file-section-info">
      <div class="file-section-info-separator"/>
      Vous êtes en cours d'inscription.<br> Veuillez vérifier les informations de votre dossier de candidature afin de finaliser votre contrat de formation. Vous recevrez votre dossier d'inscription PDF par email d'ici 15 jours ouvrés à renvoyer signé
    </div>
  </div>
  <div v-else class="file-section">
    <div class="file-section-content">
      <div>
        <div class="file-circle"/>
      </div>
      <div class="file-section-content-label">Signature du dossier</div>
      <div>
        <div class="file-icon"><img src="@/assets/img/file/padlock-close.png"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FileSignature",
  props: {
    statut: String,
    ifContratR2: Boolean
  }
};
</script>